<template>
  <v-dialog width="700px" :value="value" @input="toggleModal()" persistent>
    <v-card class="error" style="border-radius: 10px">
      <v-card-text>
        <v-row>
          <v-col class="text-center" cols="12" >
            <v-icon color="white" size="70">warning</v-icon>
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <h5 class="white--text text-center">
              {{ $t('general.privacyTermsWarning') }}
            </h5>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="d-flex justify-center align-center">
        <v-btn color="white"
               class="mr-2"
               outlined
               @click="toggleModal()">
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn color="white"
               class="error--text"
               :loading="loading"
               @click="exportFile()">
          {{ $t('general.export') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import notifications from '@/libs/notifications'
export default {
  data () {
    return {
      deletingUser: false,
      loading: false
    }
  },
  methods: {
    async exportFile () {
      try {
        if (this.loading) return
        this.loading = true
        const data = {
          fileName: 'Leads'
        }
        await this.$store.dispatch('exportFileUser', { data })
        this.toggleModal()
      } catch (e) {
        notifications.error(e)
      } finally {
        this.loading = false
      }
    },
    toggleModal () {
      this.$emit('input', false)
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>
